import { Routes } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { ErrorComponent } from './error.component';

export const errorRoute: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'accessdenied',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title'
    },
    canActivate: [UserRouteAccessService]
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/error/error.route.ts